const configuredIdleMinutes = Number(process.env.REACT_APP_SESSION_IDLE_TIMEOUT_MINUTES || 60);

export const SESSION_IDLE_TIMEOUT_MINUTES =
  Number.isFinite(configuredIdleMinutes) && configuredIdleMinutes > 0
    ? configuredIdleMinutes
    : 60;
export const SESSION_IDLE_TIMEOUT_MS = SESSION_IDLE_TIMEOUT_MINUTES * 60 * 1000;
export const SESSION_ACTIVITY_STORAGE_KEY = "polenica-session-last-activity";

export function isSessionInactive(lastActivityAt, now = Date.now()) {
  const normalizedLastActivity = Number(lastActivityAt);
  if (!Number.isFinite(normalizedLastActivity) || normalizedLastActivity <= 0) {
    return false;
  }
  return now - normalizedLastActivity >= SESSION_IDLE_TIMEOUT_MS;
}

